import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { getCategoryList } from "../redux/reduxApi/admin/CategoryReduxApi";

const useSubCategorySearch = (options = {}) => {
  const {
    pageSize = 30,
    searchField = "name",
    parentId, // 🔥 important
  } = options;

  const dispatch = useDispatch();

  const loadSubCategories = useCallback(
    async (search, loadedOptions, { page = 1 }) => {
      const searchCriteria = [];
      if (search && search.trim()) {
        searchCriteria.push({
          field: searchField,
          operation: "contains",
          value: search.trim(),
        });
      }

      if (parentId) {
        searchCriteria.push({
          field: "parentCategoryId",
          operation: "is",
          value: parentId,
        });
      }

      try {
        const response = await dispatch(
          getCategoryList({
            page,
            size: pageSize,
            search: searchCriteria,
          })
        );

        const categories = response.payload?.data || [];

        const options = categories.map((item) => ({
          label: item.name,
          value: item.ROWID,
        }));

        return {
          options,
          hasMore: categories.length === pageSize,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error("Error loading subcategories:", error);

        return {
          options: [],
          hasMore: false,
          additional: { page },
        };
      }
    },
    [dispatch, pageSize, searchField, parentId]
  );

  return { loadSubCategories };
};

export default useSubCategorySearch;